import { FAQ_FEEDBACK_LOCALSTORAGE_KEY } from '../../constants/data';
import { FeedbackData } from '../../model/preguntas/FeedbackData';

/**
 * Clase que se encarga de obtener y guardar los votos
 * de las preguntas frecuentes realizados por el usuario
 * en el localstorage.
 * Se utiliza para evitar que un usario vote una pregunta
 * más de una vez.
 */

export class FeedbackStorageManager {
  private storedFeedbacks: FeedbackData[];

  private init() {
    const storage = localStorage.getItem(FAQ_FEEDBACK_LOCALSTORAGE_KEY);
    if (storage) this.storedFeedbacks = JSON.parse(storage) as FeedbackData[];
  }

  constructor() {
    this.storedFeedbacks = [];
    this.init();
  }

  getByID(id: string): FeedbackData | undefined {
    if (!this.storedFeedbacks || this.storedFeedbacks.length === 0) return undefined;

    for (let feedback of this.storedFeedbacks) {
      if (id === feedback.idBtn) return feedback;
    }
    return undefined;
  }

  save(feedback: FeedbackData) {
    if (feedback) {
      this.storedFeedbacks.push(feedback);
      localStorage.setItem(FAQ_FEEDBACK_LOCALSTORAGE_KEY, JSON.stringify(this.storedFeedbacks));
    }
  }
  /**
   * Valida que una pregunta no haya sido
   * votada previamente.
   * Para esto, vuelve a controlar los datos
   * guardados en el localstorage.
   * @param id: identificador de pregunta
   * @returns true si no fue emitido ningún voto
   * para la pregunta.
   */
  validateVote(id: string): boolean {
    this.init();
    return this.getByID(id) === undefined;
  }
}
